import React, { useState, useEffect, useContext } from 'react';
import { loadRemoteManifest, orgId } from 'utils';
import { GlobalContext } from 'commons';

const Travel = () => {
  const [TravelComponent, setTravelComponent] = useState(null);
  const globalContext = useContext(GlobalContext);
  const { flags: { ebs_trm_enableSecuredTravelEducationPortal } } = globalContext;

  useEffect(() => {
    loadRemoteManifest({
      url: '/static_trm_mbr/travel-manifest.json',
      callback: setTravelComponent,
    });
  }, []);

  if (!TravelComponent) {
    return null;
  }

  return ebs_trm_enableSecuredTravelEducationPortal ? (
    <>
      <TravelComponent {...{ globalContext, orgId }} />
    </>
  ) : (
    <div className="container">
      <div className="well ssp-well">
        <TravelComponent {...{ globalContext, orgId }} />
      </div>
    </div>
  );
};

export default Travel;
